/**
 * Mirror of `flowlet.analytics.projection.future_value` for client-side
 * year-by-year curves. Pure-JS so we don't have to round-trip the API for
 * every point on a chart.
 */

export function futureValue(
  principal: number,
  monthlyContribution: number,
  annualRate: number,
  years: number,
): number {
  const n = Math.round(years * 12);
  if (n === 0) return principal;
  const r = annualRate / 12;
  const growth = (1 + r) ** n;
  const fvPrincipal = principal * growth;
  const fvAnnuity = Math.abs(r) < 1e-12 ? monthlyContribution * n : monthlyContribution * (growth - 1) / r;
  return fvPrincipal + fvAnnuity;
}

export type Point = { year: number; current: number; target: number };

export function buildCurve(opts: {
  startingPrincipal: number;
  currentMonthly: number;
  targetMonthly: number;
  annualRate: number;
  years: number;
  steps?: number;
}): Point[] {
  const steps = opts.steps ?? Math.max(opts.years, 12);
  const out: Point[] = [];
  for (let i = 0; i <= steps; i++) {
    const t = (i / steps) * opts.years;
    out.push({
      year: Number(t.toFixed(2)),
      current: futureValue(opts.startingPrincipal, opts.currentMonthly, opts.annualRate, t),
      target: futureValue(opts.startingPrincipal, opts.targetMonthly, opts.annualRate, t),
    });
  }
  return out;
}
